/* ============================================================
   DOGS SUPREME · <ds-nav-tagebuch>
   Futter-Tagebuch (Navigator P3, docs/navigator-plattform.md).
   Backlink-Asset: BEWUSST produktfrei (keine Bridge im Widget),
   damit Praxen/Hundeschulen es neutral empfehlen koennen.

   · Ein Eintrag pro Tag, unter 30 Sekunden: 4 Dimensionen je 3 Stufen
     (Kot, Juckreiz, Energie, Appetit) + Futter-Notiz + Ausrutscher.
   · Verlauf: letzte Eintraege mit Status-Punkten
     (grau unauffaellig / ORANGE beobachten / rot auffaellig, KEIN Gruen;
     Orange statt Blau seit Redesign 12.07.: Blau ist die Aktionsfarbe).
   · Druck-Ansicht "Fuer den Tierarzttermin": chronologische Tabelle,
     Hund-Name als Handschrift-Feld im Ausdruck (keine PII im Speicher).
   · Persistenz NUR localStorage (ds_nav_tagebuch_v1), Export = Druck,
     Loeschen-Knopf. Keine Fotos (Speicher-Quota + Datensparsamkeit).
   · Gespeichert-Feedback als STATISCHE Zeile (kein Auto-Dismiss-Timer,
     HIG-Accessibility), verschwindet erst bei erneuter Aenderung.

   UI-Schicht: assets/ds-nav-foundation.css (.dsn-*), Spec
   docs/standards/navigator-design-spec.md.
   Kompatibilitaet wie ds-audio.js (ES2015, keine #-Felder, kein
   Optional-Chaining). Pure Funktionen Node-testbar via module.exports.
   ============================================================ */
(function () {
  'use strict';

  var DIMS = [
    { key: 'kot', label: 'Kot', opts: ['Fest', 'Weich', 'Durchfall'] },
    { key: 'juck', label: 'Juckreiz', opts: ['Kein', 'Etwas', 'Stark'] },
    { key: 'energie', label: 'Energie', opts: ['Normal', 'Müde', 'Unruhig'] },
    { key: 'appetit', label: 'Appetit', opts: ['Gut', 'Mäßig', 'Kaum'] }
  ];

  /* Eintrag fuer ein Datum ersetzen oder anfuegen, absteigend sortiert. */
  function upsertEntry(entries, entry) {
    var out = [];
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].d !== entry.d) out.push(entries[i]);
    }
    out.push(entry);
    out.sort(function (a, b) { return a.d < b.d ? 1 : (a.d > b.d ? -1 : 0); });
    return out;
  }

  /* Schweregrad eines Eintrags: hoechste Stufe ueber alle Dimensionen (0..2). */
  function severity(entry) {
    var s = 0;
    for (var i = 0; i < DIMS.length; i++) {
      var v = entry[DIMS[i].key];
      if (typeof v === 'number' && v > s) s = v;
    }
    return s;
  }

  function isoToday(now) {
    var d = now || new Date();
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }

  function fmtDate(iso) {
    var p = String(iso).split('-');
    if (p.length !== 3) return iso;
    return p[2] + '.' + p[1] + '.' + p[0];
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { upsertEntry: upsertEntry, severity: severity, isoToday: isoToday, fmtDate: fmtDate, DIMS: DIMS };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-nav-tagebuch')) return;

  var LS_KEY = 'ds_nav_tagebuch_v1';

  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-nav-tagebuch"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-nav-tagebuch\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-nav-tagebuch-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-nav-tagebuch-styles';
    style.textContent = [
      "ds-nav-tagebuch .dsnt-date{font-size:13px;font-weight:600;color:#0071e3;margin:0 0 14px;font-variant-numeric:tabular-nums}",
      "ds-nav-tagebuch .dsnt-group{margin-bottom:14px}",
      "ds-nav-tagebuch .dsnt-saved{display:none;font-size:14px;font-weight:600;color:#0071e3;margin:10px 0 0;text-align:center}",
      "ds-nav-tagebuch .dsnt-saved.dsnt-show{display:block}",
      "ds-nav-tagebuch .dsnt-hist{margin-top:24px}",
      "ds-nav-tagebuch .dsnt-hist-title{font-size:16px;font-weight:600;color:#1d1d1f;margin:0 0 10px;letter-spacing:-.01em}",
      "ds-nav-tagebuch .dsnt-row{display:flex;align-items:center;gap:10px;padding:10px 2px;border-bottom:1px solid #f0f0f2}",
      "ds-nav-tagebuch .dsnt-row-date{flex:0 0 78px;font-size:13px;font-weight:600;color:#1d1d1f;font-variant-numeric:tabular-nums}",
      "ds-nav-tagebuch .dsnt-dots{display:flex;gap:6px;flex:0 0 auto}",
      "ds-nav-tagebuch .dsnt-dot{width:10px;height:10px;border-radius:50%}",
      "ds-nav-tagebuch .dsnt-dot.s0{background:#d2d2d7}",
      "ds-nav-tagebuch .dsnt-dot.s1{background:var(--dsn-warn,#b25000)}",
      "ds-nav-tagebuch .dsnt-dot.s2{background:var(--dsn-error,#d70015)}",
      "ds-nav-tagebuch .dsnt-row-note{flex:1 1 auto;font-size:12px;color:#6e6e73;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
      "ds-nav-tagebuch .dsnt-legend{font-size:12px;color:#6e6e73;margin:10px 0 0}",
      "ds-nav-tagebuch .dsnt-actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:16px}",
      "@media (max-width:480px){ds-nav-tagebuch .dsnt-actions{flex-direction:column;align-items:stretch}}",
      "ds-nav-tagebuch .dsnt-print-head{display:none}",
      "@media print{body *{visibility:hidden}ds-nav-tagebuch,ds-nav-tagebuch *{visibility:visible}",
      "ds-nav-tagebuch{position:absolute;left:0;top:0;width:100%}",
      "ds-nav-tagebuch .dsnt-form,ds-nav-tagebuch .dsnt-actions,ds-nav-tagebuch .dsnt-saved,ds-nav-tagebuch .dsn-sub,ds-nav-tagebuch .dsnt-legend{display:none!important}",
      "ds-nav-tagebuch .dsn-card{border:none;box-shadow:none;padding:0}",
      "ds-nav-tagebuch .dsnt-print-head{display:block;margin:0 0 14px}",
      "ds-nav-tagebuch .dsnt-print-head h2{font-size:20px;margin:0 0 4px}",
      "ds-nav-tagebuch .dsnt-print-head p{font-size:13px;color:#333;margin:0}",
      "ds-nav-tagebuch .dsnt-row{page-break-inside:avoid}",
      "ds-nav-tagebuch .dsnt-row-note{white-space:normal;overflow:visible;color:#333}}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  var TICK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  class DsNavTagebuch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();
      this.data = this.load() || { entries: [] };
      this.today = isoToday();
      this.draft = this.findToday() || { d: this.today, kot: 0, juck: 0, energie: 0, appetit: 0, futter: '', ausrutscher: false };
      this.render();
    }

    load() {
      try { var raw = localStorage.getItem(LS_KEY); return raw ? JSON.parse(raw) : null; }
      catch (e) { return null; }
    }
    persist() { try { localStorage.setItem(LS_KEY, JSON.stringify(this.data)); } catch (e) {} }
    findToday() {
      for (var i = 0; i < this.data.entries.length; i++) {
        if (this.data.entries[i].d === this.today) return JSON.parse(JSON.stringify(this.data.entries[i]));
      }
      return null;
    }

    /* Jede Aenderung am Entwurf blendet die Gespeichert-Zeile wieder aus
       (statisches Feedback ohne Timer, HIG). */
    touch() {
      if (this.saved) this.saved.classList.remove('dsnt-show');
    }

    segRow(dim) {
      var self = this;
      var wrap = el('div', 'dsn-seg-track');
      dim.opts.forEach(function (label, idx) {
        var btn = el('button', 'dsn-seg', label);
        btn.type = 'button';
        btn.setAttribute('aria-pressed', self.draft[dim.key] === idx ? 'true' : 'false');
        btn.addEventListener('click', function () {
          self.draft[dim.key] = idx;
          var all = wrap.querySelectorAll('.dsn-seg');
          for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', i === idx ? 'true' : 'false');
          self.touch();
        });
        wrap.appendChild(btn);
      });
      return wrap;
    }

    render() {
      var self = this;
      var card = el('div', 'dsn-card');

      var ph = el('div', 'dsnt-print-head');
      var phTitle = el('h2', '', 'Futter-Tagebuch für den Tierarzttermin');
      ph.appendChild(phTitle);
      ph.appendChild(el('p', '', 'Hund: ______________________    Zeitraum: letzte ' + Math.min(this.data.entries.length, 60) + ' Einträge    Stufen: 1 = unauffällig, 2 = beobachten, 3 = auffällig'));
      card.appendChild(ph);

      card.appendChild(el('p', 'dsn-title', 'Futter-Tagebuch'));
      card.appendChild(el('p', 'dsn-sub', 'Ein Eintrag pro Tag, unter 30 Sekunden. Deine Daten bleiben auf diesem Gerät.'));

      var form = el('div', 'dsnt-form');
      form.appendChild(el('p', 'dsnt-date', 'Eintrag für heute, ' + fmtDate(this.today)));
      DIMS.forEach(function (dim) {
        var g = el('div', 'dsnt-group');
        g.appendChild(el('span', 'dsn-label', dim.label));
        g.appendChild(self.segRow(dim));
        form.appendChild(g);
      });

      var gF = el('div', 'dsnt-group');
      var lbl = el('label', 'dsn-label', 'Futter und Snacks heute');
      lbl.setAttribute('for', 'DsntFutter');
      gF.appendChild(lbl);
      var futterInput = el('input', 'dsn-input');
      futterInput.id = 'DsntFutter';
      futterInput.type = 'text';
      futterInput.maxLength = 120;
      futterInput.placeholder = 'z. B. Rind-Mix 400 g, 2 Leckerli';
      futterInput.value = this.draft.futter || '';
      futterInput.addEventListener('input', function () { self.touch(); });
      gF.appendChild(futterInput);
      form.appendChild(gF);
      this.futterInput = futterInput;

      var list = el('div', 'dsn-list');
      var tg = el('button', 'dsn-row');
      tg.type = 'button';
      tg.setAttribute('aria-pressed', this.draft.ausrutscher ? 'true' : 'false');
      tg.appendChild(el('span', '', 'Ausrutscher: etwas Ungeplantes gefressen'));
      var tick = el('span', 'dsn-tick');
      tick.innerHTML = TICK_SVG;
      tick.setAttribute('aria-hidden', 'true');
      tg.appendChild(tick);
      tg.addEventListener('click', function () {
        self.draft.ausrutscher = !self.draft.ausrutscher;
        tg.setAttribute('aria-pressed', self.draft.ausrutscher ? 'true' : 'false');
        self.touch();
      });
      list.appendChild(tg);
      form.appendChild(list);

      var dock = el('div', 'dsn-dock');
      var btn = el('button', 'dsn-btn', this.findToday() ? 'Eintrag aktualisieren' : 'Eintrag speichern');
      btn.type = 'button';
      dock.appendChild(btn);
      form.appendChild(dock);

      var saved = el('p', 'dsnt-saved', 'Eintrag für heute gespeichert.');
      saved.setAttribute('role', 'status');
      form.appendChild(saved);
      this.saved = saved;
      card.appendChild(form);

      btn.addEventListener('click', function () {
        self.draft.futter = self.futterInput.value || ''; /* direkt aus dem DOM: Autofill feuert kein input-Event */
        self.draft.d = self.today;
        self.data.entries = upsertEntry(self.data.entries, JSON.parse(JSON.stringify(self.draft)));
        self.persist();
        saved.classList.add('dsnt-show');
        btn.textContent = 'Eintrag aktualisieren';
        self.renderHistory();
      });

      this.hist = el('div', 'dsnt-hist');
      card.appendChild(this.hist);

      var actions = el('div', 'dsnt-actions');
      var printBtn = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm', 'Für den Tierarzttermin drucken');
      printBtn.type = 'button';
      printBtn.addEventListener('click', function () { window.print(); });
      actions.appendChild(printBtn);
      var clearBtn = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm dsn-btn--danger', 'Alle Einträge löschen');
      clearBtn.type = 'button';
      clearBtn.addEventListener('click', function () {
        if (!window.confirm('Wirklich alle Tagebuch-Einträge von diesem Gerät löschen?')) return;
        self.data = { entries: [] };
        self.persist();
        self.renderHistory();
      });
      actions.appendChild(clearBtn);
      card.appendChild(actions);

      this.appendChild(card);
      this.renderHistory();
    }

    renderHistory() {
      var self = this;
      while (this.hist.firstChild) this.hist.removeChild(this.hist.firstChild);
      var entries = this.data.entries;
      if (!entries.length) return;

      this.hist.appendChild(el('p', 'dsnt-hist-title', 'Dein Verlauf'));
      var show = entries.slice(0, 60);
      show.forEach(function (e) {
        var row = el('div', 'dsnt-row');
        row.appendChild(el('span', 'dsnt-row-date', fmtDate(e.d)));
        var dots = el('span', 'dsnt-dots');
        DIMS.forEach(function (dim) {
          var v = typeof e[dim.key] === 'number' ? e[dim.key] : 0;
          var dot = el('span', 'dsnt-dot s' + v);
          dot.title = dim.label + ': ' + dim.opts[v];
          dots.appendChild(dot);
        });
        row.appendChild(dots);
        var noteTxt = (e.futter || '') + (e.ausrutscher ? (e.futter ? ', ' : '') + 'Ausrutscher' : '');
        row.appendChild(el('span', 'dsnt-row-note', noteTxt));
        self.hist.appendChild(row);
      });
      this.hist.appendChild(el('p', 'dsnt-legend',
        'Punkte je Zeile: Kot, Juckreiz, Energie, Appetit. Grau = unauffällig, Orange = beobachten, Rot = auffällig. Häufen sich rote oder orange Punkte, gehört der Verlauf in die Tierarztpraxis.'));
    }
  }

  customElements.define('ds-nav-tagebuch', DsNavTagebuch);
})();
